var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDustBin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FBE8D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1389 17.2218V24.1663C15.1389 25.7004 16.3825 26.9441 17.9167 26.9441H22.0833C23.6175 26.9441 24.8611 25.7004 24.8611 24.1663V17.2218M21.3889 19.3052V23.4718M18.6111 19.3052L18.6111 23.4718M22.7778 15.1385L21.8012 13.6736C21.5436 13.2873 21.11 13.0552 20.6456 13.0552H19.3544C18.89 13.0552 18.4564 13.2873 18.1988 13.6736L17.2222 15.1385M22.7778 15.1385H17.2222M22.7778 15.1385H26.25M17.2222 15.1385H13.75",
    stroke: "#A82C2C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDustBin);
export default __webpack_public_path__ + "static/media/dust-bin.abb4253877c3688b50f0da749087c133.svg";
export { ForwardRef as ReactComponent };